import { AddScreenshotLabelRequest, AddScreenshotLabelResponse } from '@eigtech/meetings-types'
import { contextualPost, useMutation } from '@eigtech/ui-shared-api'
import { meetingsBasePath } from './constants'
import { useInvalidateScreenshotLabels } from './getScreenshotLabels'

const addScreenshotLabel = ({
  entityId,
  meetingId,
  startTime,
  label,
  value,
}: AddScreenshotLabelRequest) =>
  contextualPost<AddScreenshotLabelResponse>(
    `${meetingsBasePath}/meeting/screenshotlabels/${entityId}/${startTime}/${meetingId}`,
    { label, value }
  )

// start meeting
export function useAddScreenshotLabel() {
  const invalidateScreenshotLabels = useInvalidateScreenshotLabels()
  return useMutation({
    mutationFn: addScreenshotLabel,
    onSuccess(__, { entityId, meetingId, startTime }) {
      invalidateScreenshotLabels({ entityId, meetingId, startTime })
    },
  })
}
